export default "__VITE_ASSET__CbidJXL2__"